@if (visible) {
  <div class="modal-overlay" (mousedown)="onOverlayClick()">
    <div class="modal-card" role="dialog" aria-modal="true"
         aria-labelledby="cost-calculation-modal-title"
         (mousedown)="$event.stopPropagation()"
         cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.escape)="close()">
      <div class="modal-head">
        <div>
          <div class="modal-sub">{{ 'adminDash.costCalculation.sub' | translate }}</div>
          <div class="modal-title" id="cost-calculation-modal-title">
            {{ 'adminDash.costCalculation.title' | translate }}
          </div>
        </div>
        <button class="modal-x" type="button" [attr.aria-label]="'general.close' | translate" (click)="close()">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
               stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 6l12 12M18 6l-12 12"/>
          </svg>
        </button>
      </div>

      <div class="modal-body" [attr.aria-busy]="isLoading">
        <p class="edit-intro">{{ 'adminDash.costCalculation.intro' | translate }}</p>

        @if (!editable) {
          <p class="kk-readonly-hint">{{ 'adminDash.costCalculation.readonlyHint' | translate }}</p>
        }

        @if (isLoading) {
          <p class="kk-status">{{ 'adminDash.costCalculation.loading' | translate }}</p>
        }

        @if (loadFailed) {
          <p class="kk-status kk-status--error" role="alert">
            {{ 'adminDash.costCalculation.loadError' | translate }}
          </p>
        }

        <div class="kk-grid">
          <label class="kk-field">
            <span class="kk-label">{{ 'adminDash.costCalculation.field.margin' | translate }}</span>
            <input class="bf-input" type="number" [min]="min" [max]="max" [step]="step"
                   [readOnly]="!editable" [attr.aria-readonly]="!editable" [disabled]="isLoading"
                   [class.bf-input--error]="isOutOfRange('margin')"
                   [attr.aria-invalid]="isOutOfRange('margin') || null"
                   #marginField="ngModel" [(ngModel)]="parameters.margin" (ngModelChange)="onParameterChange()">
          </label>

          <label class="kk-field">
            <span class="kk-label">{{ 'adminDash.costCalculation.field.overhead' | translate }}</span>
            <input class="bf-input" type="number" [min]="min" [max]="max" [step]="step"
                   [readOnly]="!editable" [attr.aria-readonly]="!editable" [disabled]="isLoading"
                   [class.bf-input--error]="isOutOfRange('overhead')"
                   [attr.aria-invalid]="isOutOfRange('overhead') || null"
                   #overheadField="ngModel" [(ngModel)]="parameters.overhead" (ngModelChange)="onParameterChange()">
          </label>

          <label class="kk-field">
            <span class="kk-label">{{ 'adminDash.costCalculation.field.travel' | translate }}</span>
            <input class="bf-input" type="number" [min]="min" [max]="max" [step]="step"
                   [readOnly]="!editable" [attr.aria-readonly]="!editable" [disabled]="isLoading"
                   [class.bf-input--error]="isOutOfRange('travel')"
                   [attr.aria-invalid]="isOutOfRange('travel') || null"
                   #travelField="ngModel" [(ngModel)]="parameters.travel" (ngModelChange)="onParameterChange()">
          </label>
        </div>

        @if (hasOutOfRange) {
          <p class="kk-status kk-status--error" role="alert">
            {{ 'adminDash.costCalculation.rangeError' | translate: {min: min, max: max} }}
          </p>
        }

        <p class="kk-formula" aria-live="polite">
          <span>{{ 'adminDash.costCalculation.formulaRemote' | translate: {margin: margin, overhead: overhead} }}</span>
          <span class="kk-formula-sep" aria-hidden="true">·</span>
          <span>{{ 'adminDash.costCalculation.formulaOnsite' | translate: {travel: travel} }}</span>
        </p>
      </div>

      <div class="modal-foot">
        <span class="modal-count">{{ 'adminDash.costCalculation.footHint' | translate }}</span>
        <button class="btn-primary" type="button" (click)="close()">{{ 'general.close' | translate }}</button>
      </div>
    </div>
  </div>
}
